import React from 'react'
import {
  AiFillFacebook,
  AiFillGithub,
  AiFillInstagram,
  AiFillLinkedin,
  AiFillTwitterSquare,
  AiOutlineWhatsApp,
} from 'react-icons/ai'
import image from './Picsart_23-03-19_09-31-11-077.jpg' 

const About = () => {
  return (
    <section  id="about" className="bg-[#0C111B]">
      <div className="px-4  mx-auto sm:max-w-xl md:max-w-full  lg:max-w-screen-xl md:px-24 lg:px-8 pt-14 lg:pt-24">
        <h1 className="lg:text-4xl text-3xl font-semibold text-center pt-6 pb-14 text-white">
          About{' '}
          <a
            target='_blank'
            href="https://github.com/codewithmahadihasan"
            className="text-violet-300"
          >
            Md. Mahadi Hasan
          </a>
        </h1>
        <div className="flex flex-col lg:flex-row  items-center gap-4  lg:gap-10 pb-20">
          <div>
            <img
              draggable='false'
              className=" w-[300px] lg:w-[1200px] rounded shadow-lg  shadow-gray-400"
              src={image}
              alt=""
            />
          </div>
          <div className="lg:pl-10 mt-10">
            <div className="mb-6 text-gray-100">
              <p className="mb-4">
                 I strongly believe in the power of teamwork and collaboration. I value open communication, transparency, and honesty. I always try to create a supportive and positive work culture where everyone can thrive and reach their full potential.
              </p>

              <p className="mt-6">
               As a Mern-Stack Developer, I have developed a strong understanding of web development and its various aspects. I am proficient in front-end technologies such as HTML, CSS, and JavaScript, and I have experience working with back-end technologies such as Node.js, Express.js, and MongoDB.
              </p>
              <p className="mt-6">
                My passion for coding has driven me to continuously improve my skills and stay up-to-date with the latest technologies and trends. I am always eager to take on new challenges and learn from my experiences.

              </p>
              <p className="mt-6">
                In my role as CEO and founder of Bright Future Software Company, I am committed to providing my clients with innovative solutions that can help them achieve their goals. I strongly believe that technology can make a positive impact on our lives and society, and I am excited to be a part of that change.

              </p>
              <p className="mt-6">
                In conclusion, I am a passionate Mern-Stack Developer and CEO with a strong desire to learn, grow, and make a positive impact. I am dedicated to delivering high-quality solutions to my clients and creating a supportive work culture for my team.

              </p>
            </div>
            <hr className="mb-5 border-gray-300" />
            <div className="flex items-center space-x-4 lg:justify-start justify-center">
              <a
                   draggable='false'
                href="https://www.facebook.com/codewithmahadihasan/"
                target="blank"
              >
                <AiFillFacebook className="text-gray-100 text-4xl transition-colors duration-300 hover:text-teal-400"></AiFillFacebook>
              </a>
              <a
                   draggable='false'
                href="https://www.instagram.com/codewithmahadihasan/"
                target="blank"
              >
                <AiFillInstagram className="text-gray-100 text-4xl transition-colors duration-300 hover:text-teal-400"></AiFillInstagram>
              </a>
              <a href="https://twitter.com/codewithmahadi/"    draggable='false' target="blank">
                <AiFillTwitterSquare className="text-gray-100 text-4xl transition-colors duration-300 hover:text-teal-400"></AiFillTwitterSquare>
              </a>
              <a    draggable='false'
                href="https://www.linkedin.com/in/codewithmahadihasan/"
                target="blank"
              >
                <AiFillLinkedin className="text-gray-100 text-4xl transition-colors duration-300 hover:text-teal-400"></AiFillLinkedin>
              </a>
              <a    draggable='false' href="https://github.com/codewithmahadihasan" target="blank">
                <AiFillGithub className="text-gray-100 text-4xl transition-colors duration-300 hover:text-teal-400"></AiFillGithub>
              </a>
              <a    draggable='false' href="https://wa.link/s4z9an" target="blank">
                <AiOutlineWhatsApp className="text-gray-100 text-4xl transition-colors duration-300 hover:text-teal-400"></AiOutlineWhatsApp>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default About
